import { Controller } from "@hotwired/stimulus"

const ACTIVE_CLASS = "active";

// The server renders every tab unhighlighted; matching one to ?current_table is this
// controller's whole job. An unrecognised value falls back to Imports, the same tab the
// server's own default renders a table for.
export default class extends Controller {
  static get targets() { return ["imports", "updates", "cancels"]; }

  connect() {
    this.currentTab().classList.add(ACTIVE_CLASS);
  }

  currentTab() {
    switch (new URLSearchParams(window.location.search).get("current_table")) {
      case "updates":
        return this.updatesTarget;
      case "cancels":
        return this.cancelsTarget;
      default:
        return this.importsTarget;
    }
  }
}
